import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <main className="min-h-screen bg-[#0A0A0A] text-[#F8F8F5] flex items-center justify-center px-6">
      <div className="noise-overlay" aria-hidden="true" />
      <motion.div
        data-testid="payment-cancel-page"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-lg w-full text-center"
      >
        <div className="w-16 h-16 rounded-full border border-[#27272A] flex items-center justify-center mx-auto">
          <XCircle className="text-[#A1A1AA]" size={28} />
        </div>
        <h1 className="font-display text-4xl font-bold tracking-tighter mt-8">Checkout cancelled.</h1>
        <p className="font-body text-[#A1A1AA] mt-4 leading-relaxed">
          No charge was made. You can return to your quote or our services whenever you're ready.
        </p>
        <div className="mt-10 flex items-center justify-center gap-4">
          <button
            data-testid="cancel-packages-btn"
            onClick={() => navigate("/services")}
            className="rounded-full bg-[#DFFF00] text-[#0A0A0A] font-body font-semibold px-8 py-4 hover:bg-[#C8E600] transition-colors"
          >
            View services
          </button>
          <button
            data-testid="cancel-home-btn"
            onClick={() => navigate("/")}
            className="rounded-full border border-[#27272A] text-[#F8F8F5] font-body px-8 py-4 hover:border-[#DFFF00] transition-colors"
          >
            Back to home
          </button>
        </div>
      </motion.div>
    </main>
  );
}
